import { createContext } from "react";
import { IPaginationContext } from "./IPaginationContext";
import { FlexGroupPagedQuery } from "../dtos";

export const flexGroupListContext = createContext<IPaginationContext<FlexGroupPagedQuery>>({} as IPaginationContext<FlexGroupPagedQuery>)